import { createRouter, createWebHistory } from 'vue-router';
import DynamicMainComponent from '@/components/DynamicMainComponent.vue'; // Новый динамический компонент

// Асинхронная загрузка компонентов
const MaterialsComponent = () => import('@/components/MaterialsComponent.vue');
const MaterialsFilterComponent = () => import('@/views/MaterialsFilterPageCompact.vue');
const CollectionsComponent = () => import('@/components/CollectionsComponent.vue');
const CollectionComponent = () => import('@/components/CollectionComponent.vue');
const ChannelsComponent = () => import('@/components/ChannelsComponent.vue');
const ChannelComponent = () => import('@/components/ChannelComponent.vue');
const ArticleComponent = () => import('@/components/ArticleComponent.vue');
const ShortViewComponent = () => import('@/components/ShortViewComponent.vue');
const SearchComponent = () => import('@/components/SearchComponent.vue');
const AboutComponent = () => import('@/components/AboutComponent.vue');
const HistoryComponent = () => import('@/components/HistoryComponent.vue');
const ShlokaManagementComponent = () => import('@/components/ShlokaManagementComponent.vue');
const ArticleGeneratorView = () => import('@/views/ArticleGeneratorView.vue');
const ApiDashboard = () => import('@/components/api/ApiDashboard.vue');
const ApiDocumentation = () => import('@/components/api/ApiDocumentation.vue');
const MeetingsDashboard = () => import('@/components/meeting/dashboard/MeetingsDashboard.vue');
const MeetingProtocolView = () => import('@/components/meeting/MeetingProtocolView.vue');
const ZvonalitikDashboard = () => import('@/components/zvonalitik/ZvonalitikDashboard.vue');
const ZvonalitikCallView = () => import('@/components/zvonalitik/ZvonalitikCallView.vue');
const ZvonalitikKnowledgeBase = () => import('@/components/zvonalitik/ZvonalitikKnowledgeBase.vue');
const ZvonalitikProfilesPage = () => import('@/views/ZvonalitikProfilesPage.vue');
const AmoCRMAnalytics = () => import('@/components/AmoCRMAnalytics.vue');
const AmoCRMMemberDetails = () => import('@/components/AmoCRMMemberDetails.vue');
const AmoCRMCallback = () => import('@/components/zvonalitik/AmoCRMCallback.vue');
const AmoCRMSettings = () => import('@/components/zvonalitik/AmoCRMSettings.vue');
const CliAuthPage = () => import('@/components/cli/CliAuthPage.vue');
const SubscriptionPage = () => import('@/components/subscription/SubscriptionPage.vue');
const HelpPage = () => import('@/views/HelpPage.vue');
const EmailLoginForm = () => import('@/components/EmailLoginForm.vue');
const ProcessingStatusPage = () => import('@/views/ProcessingStatusPage.vue');

// Базовые маршруты
let routes = [
  {
    path: '/',
    name: 'Main',
    component: DynamicMainComponent, // Используем динамический компонент
    meta: {
      title: 'Главная или Канал',
      keepAlive: true
    }
  },
  {
    path: '/about',
    name: 'About',
    component: AboutComponent,
    meta: {
      title: 'О проекте'
    }
  },
  {
    path: '/history',
    name: 'History',
    component: HistoryComponent,
    meta: {
      title: 'История просмотров'
    }
  },
  {
    path: '/materials',
    name: 'Materials',
    component: MaterialsComponent,
    meta: {
      title: 'Материалы'
    }
  },
  {
    path: '/materials/filter',
    name: 'MaterialsFilter',
    component: MaterialsFilterComponent,
    meta: {
      title: 'Поиск и фильтрация материалов'
    }
  },
  {
    path: '/collections',
    name: 'Collections',
    component: CollectionsComponent,
    meta: {
      title: 'Курсы и плейлисты'
    }
  },
  {
    path: '/collection/:id',
    name: 'Collection',
    component: CollectionComponent,
    meta: {
      title: 'Информация о курсе или плейлисте'
    }
  },
  {
    path: '/channels',
    name: 'Channels',
    component: ChannelsComponent,
    meta: {
      title: 'Каналы'
    }
  },
  {
    path: '/article/:id',
    name: 'Article',
    component: ArticleComponent,
    meta: {
      title: 'Материал'
    }
  },
  {
    path: '/short/:hash',
    name: 'ShortView',
    component: ShortViewComponent,
    props: true,
    meta: {
      title: 'Short Video'
    }
  },
  {
    path: '/channel/:id', // Маршрут с параметром id
    name: 'Channel',
    component: ChannelComponent,
    props: true, // Это позволяет передавать параметры как свойства (props)
    meta: {
      title: 'Информация о канале',
      keepAlive: true
    }
  },
  {
    path: '/search/:query/:type/:contextId?',
    name: 'Search',
    component: SearchComponent,
    props: (route) => ({
      query: route.params.query,
      type: route.params.type,
      contextId: route.params.contextId || null
    })
  },
  {
    path: '/shlokas',
    name: 'ShlokaManagement',
    component: ShlokaManagementComponent,
    meta: {
      title: 'Управление шлоками',
      requiresModerator: true
    }
  },
  {
    path: '/materials/article-generator',
    name: 'ArticleGenerator',
    component: ArticleGeneratorView,
    meta: {
      requiresAuth: false,
      title: 'Что говорит Гурудев'
    }
  },
  {
    path: '/api-settings',
    name: 'ApiSettings',
    component: ApiDashboard,
    meta: {
      requiresAuth: true,
      title: 'API Settings'
    }
  },
  {
    path: '/api-docs',
    name: 'ApiDocumentation',
    component: ApiDocumentation,
    meta: {
      requiresAuth: false,
      title: 'API Documentation'
    }
  },
  {
    path: '/meetings',
    name: 'MeetingsDashboard',
    component: MeetingsDashboard,
    meta: {
      requiresAuth: true,
      title: 'Мои встречи'
    }
  },
  {
    path: '/zvonalitik',
    name: 'ZvonalitikDashboard',
    component: ZvonalitikDashboard,
    meta: {
      requiresAuth: true,
      title: 'Аналитика звонков'
    }
  },
  {
    path: '/knowledge-base',
    name: 'ZvonalitikKnowledgeBase',
    component: ZvonalitikKnowledgeBase,
    meta: {
      requiresAuth: true,
      title: 'Образцы звонков'
    }
  },
  {
    path: '/scoring-profiles',
    name: 'ZvonalitikProfiles',
    component: ZvonalitikProfilesPage,
    beforeEnter: (to, from, next) => {
      // Feature flag: only allow admin user
      const authToken = localStorage.getItem('authToken');
      if (!authToken) {
        next('/');
        return;
      }

      // Check user in store
      import('@/store').then(storeModule => {
        const store = storeModule.default;
        const user = store.getters['user/getUser'];

        if (user && user.tg_user_id === 295557514) {
          next();
        } else {
          // Redirect to dashboard if not admin
          next('/');
        }
      });
    },
    meta: {
      requiresAuth: true,
      title: 'Профили скоринга'
    }
  },
  {
    path: '/amocrm/analytics',
    name: 'AmoCRMAnalytics',
    component: AmoCRMAnalytics,
    meta: {
      requiresAuth: true,
      title: 'Аналитика команды'
    }
  },
  {
    path: '/amocrm/member/:id',
    name: 'AmoCRMMemberDetails',
    component: AmoCRMMemberDetails,
    meta: {
      requiresAuth: true,
      title: 'Детали менеджера'
    }
  },
  {
    path: '/amocrm/callback',
    name: 'AmoCRMCallback',
    component: AmoCRMCallback,
    meta: {
      requiresAuth: true,
      title: 'amoCRM Authorization'
    }
  },
  {
    path: '/amocrm/settings',
    name: 'AmoCRMSettings',
    component: AmoCRMSettings,
    meta: {
      requiresAuth: true,
      title: 'Настройки amoCRM'
    }
  },
  {
    path: '/call/:id',
    name: 'ZvonalitikCall',
    component: ZvonalitikCallView,
    props: true,
    meta: {
      requiresAuth: true,
      title: 'Отчет о звонке'
    }
  },
  {
    path: '/meeting/:id',
    name: 'meeting-protocol',
    component: MeetingProtocolView,
    props: true,
    meta: {
      requiresAuth: true,
      title: 'Протокол встречи'
    }
  },
  {
    path: '/cli/auth',
    name: 'CliAuth',
    component: CliAuthPage,
    meta: {
      requiresAuth: false,
      title: 'CLI Authorization'
    }
  },
  {
    path: '/subscription',
    name: 'Subscription',
    component: SubscriptionPage,
    meta: {
      requiresAuth: true,
      title: 'Subscription'
    }
  },
  {
    path: '/help',
    name: 'Help',
    component: HelpPage,
    meta: {
      requiresAuth: false,
      title: 'Help'
    }
  },
  {
    path: '/reset-password',
    name: 'ResetPassword',
    component: EmailLoginForm,
    meta: {
      requiresAuth: false,
      title: 'Сброс пароля'
    }
  },
  {
    path: '/set-password',
    name: 'SetPassword',
    component: EmailLoginForm,
    meta: {
      requiresAuth: false,
      title: 'Установка пароля'
    }
  },
  {
    path: '/processing/:token',
    name: 'ProcessingStatus',
    component: ProcessingStatusPage,
    meta: {
      requiresAuth: false,
      title: 'Processing status'
    }
  }
];

// Создаем роутер
export const router = createRouter({
  history: createWebHistory('/app/'),
  routes
});
